import { Phone, Heart, Users } from 'lucide-react';

export const services = [
  {
    slug: 'erstgespraech',
    icon: Phone,
    title: 'Erstgespräch',
    subtitle: 'Dein erster Schritt',
    shortDescription:
      'Ein kostenloses, unverbindliches Gespräch, in dem wir uns kennenlernen und gemeinsam schauen, wie ich dich bestmöglich begleiten kann.',
    image:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/173yiyhv_Erstgespr%C3%A4ch.jpg',
    detailImage:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/wcxb4euc_Unterseite%20erstgespr%C3%A4ch.jpg',
    fullDescription: [
      'In einem ersten kostenlosen Gespräch per Telefon nehmen wir uns 30 Minuten Zeit, um über dein Anliegen, deine Anforderungen und Fragen zu sprechen.',
      'Darauf abgestimmt lernst du meine Lösungsansätze kennen. Ich nehme mir die Zeit, dir zuzuhören und ein Gefühl dafür zu bekommen, wo du gerade stehst und wohin du möchtest.',
      'Ein persönliches Kennenlern-Gespräch ist das Fundament für ein maßgeschneidertes 1:1 Coaching. Es ist mir wichtig, dass du dich von Anfang an gut aufgehoben fühlst – denn Vertrauen ist die Basis jeder Zusammenarbeit.',
      'Das Erstgespräch ist völlig unverbindlich. Danach entscheidest du in Ruhe, ob und wie wir zusammenarbeiten möchten.',
    ],
    features: ['Dauer: 30 Minuten', 'Kostenlos & unverbindlich', 'Per Telefon'],
    price: 'Kostenlos',
  },
  {
    slug: '1-zu-1-coaching',
    icon: Heart,
    title: '1:1 Coaching',
    subtitle: 'Deine persönliche Begleitung',
    shortDescription:
      'Professionelle Unterstützung für deine persönliche Entwicklung, innere Balance und Veränderung – individuell auf dich abgestimmt.',
    image:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/yvif4myu_1%20zu%201%20coaching.jpg',
    detailImage:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/wntmq7a1_Unterseite%20unterseite%201%20zu%201.jpg',
    fullDescription: [
      'Im 1:1 Coaching begleite ich dich mit Herz, Verstand und Erfahrung auf deinem Weg zu mehr Leichtigkeit, innerem Frieden und einem bewussteren Leben.',
      'Ob alte emotionale Wunden, wiederkehrende Muster oder das Gefühl, festzustecken – gemeinsam finden wir neue Perspektiven, lösen Blockaden und stärken deine innere Kraft.',
      'Jede Sitzung wird individuell auf deine Bedürfnisse abgestimmt. Ich arbeite mit bewährten Methoden aus der systemischen Beratung, der Achtsamkeitspraxis und der emotionalen Begleitung.',
      'Die Anzahl der Sitzungen richtet sich nach deinen individuellen Bedürfnissen. Du bestimmst das Tempo – ich begleite dich dabei.',
      'Mein Coaching findet vor Ort, online oder bei dir zu Hause statt – je nachdem, was sich für dich am besten anfühlt.',
    ],
    features: [
      'Dauer: 60 Minuten pro Sitzung',
      'Individuell abgestimmt',
      'Vor Ort, online oder beim Kunden',
    ],
    price: 'Auf Anfrage',
  },
  {
    slug: 'family-flow-coaching',
    icon: Users,
    title: 'Family Flow Coaching',
    subtitle: 'Harmonie für die ganze Familie',
    shortDescription:
      'Gemeinsam entwickeln wir Strategien, die euren Familienalltag leichter, liebevoller und verbundener machen.',
    image:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/250hk1k3_Family%20Flow%20Coaching.jpg',
    detailImage:
      'https://customer-assets.emergentagent.com/job_44f8d55e-47d0-4698-9779-c21737e71933/artifacts/77c4wb0e_Unterseite%20Family%20Flow%20coaching.jpg',
    fullDescription: [
      'Familien sind lebendige Systeme – und manchmal gerät das Zusammenspiel aus dem Gleichgewicht. Im Family Flow Coaching begleite ich euch als Familie dabei, wieder zueinanderzufinden und einen harmonischen Alltag zu gestalten.',
      'Ob Kommunikationsschwierigkeiten, Konflikte zwischen Eltern und Kindern, Patchwork-Herausforderungen oder der Wunsch nach mehr Leichtigkeit im Miteinander – ich helfe euch, neue Wege zu entdecken.',
      'Gemeinsam schauen wir auf die Dynamiken in eurer Familie: Was läuft gut? Wo hakt es? Welche unausgesprochenen Bedürfnisse gibt es? Durch gezielte Übungen, offene Gespräche und alltagstaugliche Strategien stärken wir das Fundament eurer Familie.',
      'Jede Familie ist einzigartig – deshalb gibt es bei mir keine Lösungen von der Stange. Ich arbeite empathisch, wertschätzend und lösungsorientiert, damit ihr als Familie wieder in euren ganz eigenen Flow kommt.',
      'Die Sitzungen können als Paar, mit der ganzen Familie oder auch als Einzelperson stattfinden, um die eigene Rolle im Familiensystem zu reflektieren.',
    ],
    features: [
      'Dauer: 60–90 Minuten pro Sitzung',
      'Für Paare & Familien',
      'Vor Ort, online oder beim Kunden',
    ],
    price: 'Auf Anfrage',
  },
];
